// @flow
import React from 'react';
import styled, {css} from 'styled-components';

const ButtonGroup = styled.div`
  display: ${({ fillContainer }) => (fillContainer ? 'flex' : 'inline-flex')};
  justify-content: center;
  align-items: center;
  padding: 0.75rem 0;
  
   ${({ alignRight }) => alignRight && css`
    justify-content: flex-end;
    align-items: center;
  `}
     
   ${({ fillContainer }) => fillContainer && css`
      width: 100%;
  `}  
   
   ${({ alignLeft}) => alignLeft && css`
    justify-content: flex-start;
    align-items: center;
  `}   
   
   ${({ disabled}) => disabled && css`
      opacity: 0.8;
      pointer-events: none;
  `}
   
  && {
    button:not(:last-of-type) {
      margin-right: 0.5rem;
    }
  }

`;

export default ButtonGroup;



// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/components/Button/ButtonGroup.js